/**
 * URL-friendly slug shared by the web app and the API. Org, project, and
 * research-guide slugs are generated server-side but the marketing routes and
 * sitemap derive their own slugs from the same titles, so both runtimes must
 * agree character-for-character or the links they emit stop resolving.
 *
 * Non-word characters are dropped rather than collapsed to hyphens, so "C++"
 * slugs to "c". Callers that need a guaranteed non-empty slug must handle the
 * empty string themselves.
 */
export function slugify(text: string) {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w-]+/g, "") // Remove all non-word chars
    .replace(/--+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text
}
